// // src/hooks/useAuth.js - Create this new file
// import { useState, useEffect, createContext, useContext } from 'react';

// const AuthContext = createContext();

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error('useAuth must be used within an AuthProvider');
//   }
//   return context;
// };

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [token, setToken] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Check for existing token on app load
//     const savedToken = localStorage.getItem('access_token');
//     if (savedToken) {
//       setToken(savedToken);
//       // Verify token is still valid
//       verifyToken(savedToken);
//     } else {
//       // Create guest account immediately
//       createGuestAccount();
//     }
//   }, []);

//   const verifyToken = async (token) => {
//     try {
//       const response = await fetch('/api/users/me', {
//         headers: {
//           'Authorization': `Bearer ${token}`
//         }
//       });

//       if (response.ok) {
//         const userData = await response.json();
//         setUser(userData);
//         setToken(token);
//       } else {
//         // Token invalid, create new guest account
//         localStorage.removeItem('access_token');
//         createGuestAccount();
//       }
//     } catch (error) {
//       console.error('Error verifying token:', error);
//       createGuestAccount();
//     } finally {
//       setLoading(false);
//     }
//   };

//   const createGuestAccount = async () => {
//     try {
//       console.log('Creating guest account...');
      
//       const guestEmail = `guest_${Date.now()}@sterling.demo`;
//       const guestPassword = 'demo123';

//       // Register guest user
//       const registerResponse = await fetch('/api/auth/register', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           email: guestEmail,
//           password: guestPassword,
//           first_name: 'Demo',
//           last_name: 'User',
//           company_name: 'Demo Company'
//         })
//       });

//       if (!registerResponse.ok) {
//         const errorData = await registerResponse.text();
//         console.error('Registration failed:', errorData);
//         throw new Error('Registration failed');
//       }

//       // Login the guest user
//       const formData = new FormData();
//       formData.append('username', guestEmail);
//       formData.append('password', guestPassword);

//       const loginResponse = await fetch('/api/auth/login', {
//         method: 'POST',
//         body: formData
//       });

//       if (!loginResponse.ok) {
//         const errorData = await loginResponse.text();
//         console.error('Login failed:', errorData);
//         throw new Error('Login failed');
//       }

//       const loginData = await loginResponse.json();
//       const newToken = loginData.access_token;
      
//       localStorage.setItem('access_token', newToken);
//       setToken(newToken);
//       setUser(loginData.user);
      
//       console.log('Guest account created successfully');
      
//     } catch (error) {
//       console.error('Error creating guest account:', error);
//       // Set a basic token for demo mode
//       const demoToken = 'demo-token';
//       localStorage.setItem('access_token', demoToken);
//       setToken(demoToken);
//       setUser({ 
//         id: 1, 
//         email: 'demo@sterling.com', 
//         first_name: 'Demo', 
//         last_name: 'User' 
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const logout = () => {
//     localStorage.removeItem('access_token');
//     setToken(null);
//     setUser(null);
//     createGuestAccount();
//   };

//   const value = {
//     user,
//     token,
//     loading,
//     logout,
//     createGuestAccount
//   };

//   return (
//     <AuthContext.Provider value={value}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// // src/hooks/useAuth.js - Updated with token update function
// import { useState, useEffect, createContext, useContext } from 'react';

// const AuthContext = createContext();

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error('useAuth must be used within an AuthProvider');
//   }
//   return context;
// };

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [token, setToken] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const initializeAuth = async () => {
//       // Check for existing token on app load
//       const savedToken = localStorage.getItem('access_token');
      
//       if (savedToken) {
//         setToken(savedToken);
//         // Verify token is still valid
//         await verifyTokenFunction(savedToken);
//       } else {
//         // Create guest account immediately
//         await createGuestAccountFunction();
//       }
//     };

//     const verifyTokenFunction = async (tokenToVerify) => {
//       try {
//         const response = await fetch('/api/users/me', {
//           headers: {
//             'Authorization': `Bearer ${tokenToVerify}`
//           }
//         });

//         if (response.ok) {
//           const userData = await response.json();
//           setUser(userData);
//           setToken(tokenToVerify);
//         } else {
//           // Token invalid, create new guest account
//           localStorage.removeItem('access_token');
//           await createGuestAccountFunction();
//         }
//       } catch (error) {
//         console.error('Error verifying token:', error);
//         await createGuestAccountFunction();
//       } finally {
//         setLoading(false);
//       }
//     };

//     const createGuestAccountFunction = async () => {
//       try {
//         console.log('Creating guest account...');
        
//         const guestEmail = `guest_${Date.now()}@sterling.demo`;
//         const guestPassword = 'demo123';

//         // Register guest user
//         const registerResponse = await fetch('/api/auth/register', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             email: guestEmail,
//             password: guestPassword,
//             first_name: 'Demo',
//             last_name: 'User',
//             company_name: 'Demo Company'
//           })
//         });

//         if (!registerResponse.ok) {
//           const errorData = await registerResponse.text();
//           console.error('Registration failed:', errorData);
//           throw new Error('Registration failed');
//         }

//         // Login the guest user
//         const formData = new FormData();
//         formData.append('username', guestEmail);
//         formData.append('password', guestPassword);

//         const loginResponse = await fetch('/api/auth/login', {
//           method: 'POST',
//           body: formData
//         });

//         if (!loginResponse.ok) {
//           const errorData = await loginResponse.text();
//           console.error('Login failed:', errorData);
//           throw new Error('Login failed');
//         }

//         const loginData = await loginResponse.json();
//         const newToken = loginData.access_token;
        
//         localStorage.setItem('access_token', newToken);
//         setToken(newToken);
//         setUser(loginData.user);
        
//         console.log('Guest account created successfully');
        
//       } catch (error) {
//         console.error('Error creating guest account:', error);
//         // Set a basic token for demo mode
//         const demoToken = 'demo-token';
//         localStorage.setItem('access_token', demoToken);
//         setToken(demoToken);
//         setUser({ 
//           id: 1, 
//           email: 'demo@sterling.com', 
//           first_name: 'Demo', 
//           last_name: 'User' 
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     initializeAuth();
//   }, []); // Empty dependency array is safe here

//   const updateToken = (newToken) => {
//     console.log('Updating authentication token');
//     localStorage.setItem('access_token', newToken);
//     setToken(newToken);
    
//     // Optionally verify the new token
//     fetch('/api/users/me', {
//       headers: {
//         'Authorization': `Bearer ${newToken}`
//       }
//     })
//     .then(response => response.ok ? response.json() : null)
//     .then(userData => {
//       if (userData) {
//         setUser(userData);
//       }
//     })
//     .catch(error => {
//       console.error('Error verifying new token:', error);
//     });
//   };

//   const logout = () => {
//     localStorage.removeItem('access_token');
//     setToken(null);
//     setUser(null);
//     // Will trigger useEffect to create new guest account
//     window.location.reload();
//   };

//   const createGuestAccount = async () => {
//     // This can be called from components if needed
//     window.location.reload();
//   };

//   const value = {
//     user,
//     token,
//     loading,
//     logout,
//     createGuestAccount,
//     updateToken
//   };

//   return (
//     <AuthContext.Provider value={value}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// // src/hooks/useAuth.js - Updated to handle real authentication
// import { useState, useEffect, createContext, useContext } from 'react';

// const AuthContext = createContext();

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error('useAuth must be used within an AuthProvider');
//   }
//   return context;
// };

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [token, setToken] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isAuthenticated, setIsAuthenticated] = useState(false);

//   useEffect(() => {
//     const initializeAuth = async () => {
//       // Check for existing token on app load
//       const savedToken = localStorage.getItem('access_token');
      
//       if (savedToken && savedToken !== 'demo-token') {
//         // Verify real token
//         await verifyTokenFunction(savedToken);
//       } else if (savedToken === 'demo-token') {
//         // Handle demo mode
//         const demoMode = localStorage.getItem('demo_mode');
//         if (demoMode === 'true') {
//           setToken('demo-token');
//           setUser({
//             id: 1,
//             email: 'demo@sterling.com',
//             first_name: 'Demo',
//             last_name: 'User',
//             company_name: 'Demo Company'
//           });
//           setIsAuthenticated(true);
//         }
//         setLoading(false);
//       } else {
//         // No token, user needs to log in
//         setLoading(false);
//       }
//     };

//     const verifyTokenFunction = async (tokenToVerify) => {
//       try {
//         const response = await fetch('/api/users/me', {
//           headers: {
//             'Authorization': `Bearer ${tokenToVerify}`
//           }
//         });

//         if (response.ok) {
//           const userData = await response.json();
//           setUser(userData);
//           setToken(tokenToVerify);
//           setIsAuthenticated(true);
//         } else {
//           // Token invalid, clear it
//           localStorage.removeItem('access_token');
//           setIsAuthenticated(false);
//         }
//       } catch (error) {
//         console.error('Error verifying token:', error);
//         localStorage.removeItem('access_token');
//         setIsAuthenticated(false);
//       } finally {
//         setLoading(false);
//       }
//     };

//     initializeAuth();
//   }, []);

//   const login = (userData, accessToken) => {
//     setUser(userData);
//     setToken(accessToken);
//     setIsAuthenticated(true);
//     localStorage.setItem('access_token', accessToken);
//   };

//   const logout = () => {
//     localStorage.removeItem('access_token');
//     localStorage.removeItem('demo_mode');
//     setToken(null);
//     setUser(null);
//     setIsAuthenticated(false);
//   };

//   const updateToken = (newToken) => {
//     localStorage.setItem('access_token', newToken);
//     setToken(newToken);
//   };

//   const value = {
//     user,
//     token,
//     loading,
//     isAuthenticated,
//     login,
//     logout,
//     updateToken
//   };

//   return (
//     <AuthContext.Provider value={value}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// src/hooks/useAuth.js - Fixed to prevent hook order issues
import { useState, useEffect, createContext, useContext } from 'react';
import { API_BASE_URL } from '../utils/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [initialized, setInitialized] = useState(false);

  // Single useEffect for initialization - prevents hook order issues
  useEffect(() => {
    if (initialized) return; // Prevent multiple initialization

    const initializeAuth = async () => {
      try {
        // Check for existing token on app load
        const savedToken = localStorage.getItem('access_token');
        
        if (savedToken && savedToken !== 'demo-token') {
          // Verify real token
          await verifyTokenFunction(savedToken);
        } else if (savedToken === 'demo-token') {
          // Handle demo mode
          const demoMode = localStorage.getItem('demo_mode');
          if (demoMode === 'true') {
            setToken('demo-token');
            setUser({
              id: 1,
              email: 'demo@sterling.com',
              first_name: 'Demo',
              last_name: 'User',
              company_name: 'Demo Company'
            });
            setIsAuthenticated(true);
          }
        }
        // If no token, user needs to log in (isAuthenticated stays false)
      } catch (error) {
        console.error('Auth initialization error:', error);
        // Clear invalid tokens
        localStorage.removeItem('access_token');
        localStorage.removeItem('demo_mode');
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
        setInitialized(true);
      }
    };

    const verifyTokenFunction = async (tokenToVerify) => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/users/me`, {
          headers: {
            'Authorization': `Bearer ${tokenToVerify}`
          }
        });

        if (response.ok) {
          const userData = await response.json();
          setUser(userData);
          setToken(tokenToVerify);
          setIsAuthenticated(true);
        } else {
          // Token invalid, clear it
          localStorage.removeItem('access_token');
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Error verifying token:', error);
        localStorage.removeItem('access_token');
        setIsAuthenticated(false);
      }
    };

    initializeAuth();
  }, [initialized]); // Only depend on initialized flag

  const login = (userData, accessToken) => {
    setUser(userData);
    setToken(accessToken);
    setIsAuthenticated(true);
    localStorage.setItem('access_token', accessToken);
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('demo_mode');
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
  };

  const updateToken = (newToken) => {
    localStorage.setItem('access_token', newToken);
    setToken(newToken);
    
    // Optionally verify the new token
    fetch(`${API_BASE_URL}/api/users/me`, {
      headers: {
        'Authorization': `Bearer ${newToken}`
      }
    })
    .then(response => response.ok ? response.json() : null)
    .then(userData => {
      if (userData) {
        setUser(userData);
      }
    })
    .catch(error => {
      console.error('Error verifying new token:', error);
    });
  };

  const value = {
    user,
    token,
    loading,
    isAuthenticated,
    login,
    logout,
    updateToken
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};